// extracted by mini-css-extract-plugin
export default {"error-message-box":"NumberInput_error-message-box__nvB03"};